import { Component, OnInit , Inject, SecurityContext } from '@angular/core';
import { ConfigurationService } from '../../providers/configuration/configuration.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import * as Feather from 'feather-icons';
import { DomSanitizer } from '@angular/platform-browser';
import { WhatsNewData } from 'src/app/app.interfaces';


@Component({
  selector: 'app-whats-new',
  templateUrl: './whats-new.component.html',
  styleUrls: ['./whats-new.component.scss']
})
export class WhatsNewComponent implements OnInit {
  slides: WhatsNewData[] | null = null;
  currentSlideIndex = 0;
  whatsnewLink: string = '';
  MAX_VISIBLE_INDICATORS = 5;
  min = 0;
  max = this.MAX_VISIBLE_INDICATORS - 1;

  constructor(
    private dialogRef: MatDialogRef<WhatsNewComponent>,
    private configService: ConfigurationService,
    private domSanitizer : DomSanitizer,
  ) {
    const whatsNewData = this.configService.remoteConfigCacheObj.WHATS_NEW?.data;
    try {
        this.slides = whatsNewData ? JSON.parse(JSON.stringify(whatsNewData)) : null;
    } catch(e) {
      this.slides = null;
      console.error('Error parsing whats new data', e);
    }
    this.whatsnewLink = this.configService.remoteConfigCacheObj.WHATS_NEW?.WHATS_NEW_LINK;
    this.slides?.forEach((slide, index) => {
      slide.video_url = slide.video_url && this.domSanitizer.bypassSecurityTrustResourceUrl(slide.video_url);
      slide.className = this.getIndicatorClass(index);
    })
  }

  ngOnInit(): void {
    // If whatsnewLink is present and slides length is 0, then opening the link.
    if (this.whatsnewLink && (!this.slides || this.slides?.length === 0)) {
      window.open(this.whatsnewLink, '_blank');
      this.dialogRef.close();
    }
  }

  // The load() method resets the video to its initial state when switching between slides.
  resetVideo() {
    const videoElement = document.querySelector('video');
    if (videoElement) {
      videoElement.load();
    }
  }

  goToSlide(index: number) {
    this.resetVideo();
    this.currentSlideIndex = index;
    this.updateMinMax(index);
    this.updateSlide();
  }
  
  nextSlide() {
    if (this.currentSlideIndex < this.slides.length - 1) {
      this.resetVideo();
      this.currentSlideIndex++;
      this.updateMinMax(this.currentSlideIndex);
    }
    this.updateSlide();
  }

  previousSlide() {
    if (this.currentSlideIndex > 0) {
      this.resetVideo();
      this.currentSlideIndex--;
      this.updateMinMax(this.currentSlideIndex);
    }
    this.updateSlide();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  get currentSlide() {
    return this.slides[this.currentSlideIndex];
  }

  updateMinMax(currentIndex: number) {
    const halfVisible = Math.floor(this.MAX_VISIBLE_INDICATORS / 2);
    const totalSlides = this.slides.length;
  
    // Determine the min and max boundaries for visible indicators.
    if (totalSlides <= this.MAX_VISIBLE_INDICATORS) {
      this.min = 0;
      this.max = totalSlides - 1;
    } else if (currentIndex <= halfVisible) {
      this.min = 0;
      this.max = this.MAX_VISIBLE_INDICATORS - 1;
    } else if (currentIndex >= totalSlides - halfVisible) {
      this.min = totalSlides - this.MAX_VISIBLE_INDICATORS;
      this.max = totalSlides - 1;
    } else {
      this.min = currentIndex - halfVisible;
      this.max = currentIndex + halfVisible;
    }
  }  

  getIndicatorClass(index: number): string {
    // If the index is out of bounds, hide the dots.
    if(index < this.min || index > this.max) {
      return 'hidden';
    }
  
    // Active or standard dot size for all visible dots
    return index === this.currentSlideIndex ? 'active' : 'std';
  }

  /**
   * Previously, getIndicatorClass was called in each change detection cycle continuously, but we don't require it. We should only
   * update class when some action is done like next/previous, gotoSlide etc.   
   */
  updateSlide() { 
    this.slides = this.slides.map((slide, i) => {
      return {
        ...slide,
        className: this.getIndicatorClass(i)
    }});
  }

}
